export default "__VITE_ASSET__BVmREdSh__"